export default {
  send: 'Senda',
  forward: 'Áfram',
  OK: 'Staðfesta',
  cancel: 'Hætta við',
  back: 'Til baka',
  addToOrder: 'Setja í körfu',
  updateProduct: 'Uppfæra pöntun',
  chooseOptions: 'Panta',

  banner: {
    title: 'Lokað er fyrir pantanir',
    subtitle: 'Við opnum fyrir pantanir kl. {openingHour}',
  },

  frontpage: {
    imagesSection: 'Njóttu matarins í góðu umhverfi',
  },

  catering: {
    title: 'Pantaðu hér',
    amount: 'Fjöldi bakka',
    order: 'Ganga frá pöntuninni',
    deliveryMethod: 'Sótt eða sent?',
    paymentMethod: 'Hvernig viltu greiða?',
    submit: {
      errors: {
        title: 'Villa',
        message: 'Vinsamlegast athugaðu hvort allt sé útfyllt',
      },
    },
    content: {
      title: 'Veisluþjónusta',
      line1: 'Er veisla framundan?',
      line2: 'Miniborgaraveislubakkarnir eru skemmtileg og bragðgóð tilbreyting á veisluborðið. Fimmtán kaldir og krúttlegir borgarar á hverjum bakka.',
      line3: 'Pantið í síðasta lagi kl. 13:00 næsta virka dag fyrir afhendingardag. Ath. að pantanir fyrir föstudaga, laugardaga, sunnudaga og mánudaga þurfa að berast fyrir kl 13:00 á fimmtudeginum fyrir þá helgina.',
      ul: {
        li1: '15 borgarar á bakka',
        li2: 'Verð á bakka er 5.499 kr.',
        li3: 'Miðað við 3-5 borgara á mann',
        li4: 'Pantið tímanlega',
      },
    },
    form: {
      title: 'Pöntunin þín',
      login: 'Innskráning',
      total: 'Heildarfjöldi hamborgarabakka:',
      trays: 'bakkar',
      totalItems: 'borgarar, matur fyrir um {amount} manns',
      price: 'Verð samtals:',
      deliveryDate: 'Hvenær viltu sækja?',
      deliveryTime: 'Klukkan hvað viltu sækja?',
      deliveryLocation: 'Sækja á',
      deliveryInfo: 'Upplýsingar um þig',
      name: 'Nafn *',
      email: 'Netfang *',
      phone: 'Sími *',
      comment: 'Annað sem þú vilt að komi fram',
      submit: 'Staðfesta pöntun',
      errors: {
        name: 'Nafn má ekki vera tómt',
        phone: 'Símanúmer má ekki vera tómt',
      },
    },
  },

  user: {
    authenticate: 'Innskráning',
    phoneNumber: 'Símanúmer',
    verificationCode: 'Staðfestingarkóði',
    fullname: 'Nafn á pöntun',
    address: 'Heimilisfang',
    postalCode: 'Póstnúmer',
    validation: {
      name: 'Nafn þarf að vera að minnsta kosti 3 stafir',
      address: 'Heimilisfang vantar',
      postalCode: 'Póstnúmer vantar',
    },
    addAddress: 'Bæta við heimilisfangi',
  },

  checkout: {
    hintPhoneNumber: 'Sláðu inn símanúmer sem getur tekið við SMS. Við munum senda þér kóða til að staðfesta að þú sért handhafi símanúmersins.',
    hintVerificationCode: 'Við höfum sent þér staðfestingarkóða í SMS. Staðfestu símanúmerið þitt með því að slá hann inn.',
    hintFullname: 'Staðfestu að nafnið á pöntuninni sé rétt.',
    hintAddress: 'Skráðu heimilisfang fyrir heimsendingu.',
  },

  payment: {
    locations: 'Veldu staðsetningu',
    methods: 'Greiðsluleiðir',
    header: 'Greiðsluupplýsingar',
    noDeliveryChosen: 'Veldu hvernig afhending fer fram.',
    phoneNumber: 'Símanúmer',
    cardNumber: 'Kortanúmer',
    expiration: 'Gildistími',
    expirationMonth: 'Mánuður',
    expirationYear: 'Ár',
    ccv: 'Öryggisnúmer',
    cancel: 'Hætta við',
    submitForm: 'Staðfesta greiðsluupplýsingar',
    hintPaymentData: 'Pöntunin verður greidd með korti með númerið ****-****-****-{lastFour}',
    aur: {
      paymentPendingTitle: 'Beðið greiðslu',
      paymentPendingMessage: 'Kláraðu að greiða í gegnum Aur appið til að ljúka pöntun.',
    },
    secure3d: {
      hint: 'Smelltu á “Senda” til að hefja sterka auðkenningu (SCA) á greiðslukortinu.',
      about: 'Hvað er sterk auðkenning (SCA)?',
      submit: 'Senda',
      cancel: 'Hætta við',
    },
    valitorPage: {
      hint: 'Smelltu á “Senda” til að greiða á greiðslusíðu Valitor.',
      submit: 'Senda',
      cancel: 'Hætta við',
      footer: 'Ef þú villt hætta við eða þegar greiðslu er lokið er óhætt að loka greiðslusíðunni til að koma til baka.',
    },
    validation: {
      cardNumber: {
        required: 'Það vantar kortanúmer',
      },
      ccv: {
        required: 'Það vantar öryggisnúmer',
      },
      expirationMonth: {
        required: 'Það vantar gildistíma',
      },
      expirationYear: {
        required: 'Það vantar gildistíma',
      },
      phoneNumber: {
        required: 'Það vantar símanúmer',
        tooShort: 'Símanúmer er of stutt',
      },
    },
    errorFromPaymentService: 'Greiðsluhirðir gat ekki framkvæmt greiðslu.',
  },

  deliveryMethods: {
    deliveryMethods: 'Afhending',
    noDeliveryMethodAllowed: 'Enginn afhendingarleið í boði. Mögulega er valin staðsetning lokuð.',
  },

  promo: {
    view: 'Sjá nánar',
  },

  email: {
    contact: {
      title: 'Hafa samband',
      name: 'Nafn *',
      email: 'Netfang *',
      message: 'Skilaboð *',
      successDialog: {
        title: 'Póstur sendur',
        message: 'Takk fyrir skilaboðin. Við verðum í bandi ef á við.',
      },
    },
    application: {
      successDialog: {
        title: 'Póstur sendur',
        message: 'Takk fyrir umsóknina. Við verðum í bandi.',
      },
    },
    errors: {
      name: 'Nafn má ekki vera tómt',
      email: 'Netfang má ekki vera tómt',
      message: 'Skilaboð mega ekki vera tóm',
      emailInvalid: 'Netfang er á röngu formi',
    },
    buttons: {
      clear: 'Hreinsa',
      submit: 'Senda',
    },
    successDialog: {
      title: 'Tölvupóstur sendur',
      message: '',
    },
  },

  categoryTabs: {
    view: 'Skoða fleiri máltíðir ',
  },

  order: {
    footer: 'Þín pöntun',
    header: 'Pöntunin þín',
    thankYou: 'Takk fyrir pöntunina!',
    thankYouCateringDetails: 'Pöntun verður framleidd og afhent þann {delivered}',
    thankYouDetails: 'Pöntunin þín hefur verið móttekin og verður tilbúin eftir um það bil {wait} mín. Láttu okkur á afgreiðsluborðinu vita þegar þú ert komin(n). Verði þér að góðu!',
    thankYouDetailsOnSite: 'Pöntunin þín hefur verið móttekin og verður tilbúin eftir um það bil {wait} mín. Náðu þér í hnífapör og glas, finndu þér laust sæti. Við köllum svo upp nafnið á pöntuninni þegar hún er tilbúin. Verði þér að góðu!',
    thankYouDetailsQR: 'Pöntunin verður tilbúin fljótlega. Hafiru áhuga á að panta meira þarftu aðeins að skanna kóðann aftur. Verði þér að góðu.',
    isEmpty: 'Þú hefur ekki sett neitt í pöntunina þína. Skoðaðu matseðilinn og bættu við pöntunina.',
    total: 'Heildarupphæð',
    checkout: 'Ganga frá pöntun',
    confirm: 'Staðfesta pöntun',
    productAdded: '{product} bætt við pöntun',
    productUpdated: '{product} breytt',
    removeFromOrder: 'Fjarlægja',
    editProduct: 'Breyta',
    viewMenu: 'Aftur í matseðil',
    order: 'Panta',
    coupon: 'Afsláttarkóði',
    removeProduct: {
      title: 'Fjarlægja úr pöntun',
      message: '{product} verður fjarlægt úr pöntuninni',
    },
    sendOrder: {
      title: 'Staðfesta pöntun',
      message: 'Eftir að smellt hefur verið á staðfesta er pöntun vistuð og afgreidd.',
    },
  },

  location: {
    openingHours: 'Opið í dag',
    noOpeningHours: 'Lokað í dag',
    waitingTimes: {
      minutes: 'mínútur',
    },
    closed: 'Í augnablikinu er lokað fyrir pantanir. Vinsamlegast reyndu aftur innan opnunartíma.',
  },

  product: {
    ingredients: {
      title: 'Innihaldslýsing',
    },
  },

  footer: {
    openingHours: 'Opið alla daga',
  },

  form: {
    months: {
      jan: 'Janúar',
      feb: 'Febrúar',
      mar: 'Mars',
      apr: 'Apríl',
      mai: 'Maí',
      jun: 'Júní',
      jul: 'Júlí',
      aug: 'Ágúst',
      sep: 'September',
      oct: 'Október',
      nov: 'Nóvember',
      dec: 'Desember',
    },
  },

  errors: {
    default: {
      title: 'Upp hefur komið villa',
      message: 'Aðgerð skilaði villunni: {error}',
    },
    email: {
      title: 'Villa',
      message: 'Ekki tókst að senda skilaboð. Þú getur reynt aftur eða sent okkur tölvupóst beint á americanstyle@americanstyle.is',
    },
    code: {
      500: {
        title: 'Villa frá vefþjónustu',
        message: 'Vefþjónusta gat ekki framkvæmt aðgerð: "{error}"',
      },
      pilotErrorCouldNotCreateOrder: {
        title: 'Gat ekki vistað pöntun',
        message: '{error}',
      },
      pilotErrorOrderNotSaved: {
        title: 'Gat ekki vistað pöntun',
        message: '{error}',
      },
      pilotErrorNoData: {
        title: 'Gögn vantar',
        message: 'Pöntun var ekki vistuð. Gögn voru ekki rétt formuð: {error}',
      },
      pilotErrorPaymentGatewayError: {
        title: 'Villa í samskiptum við greiðsluþjónustu',
        message: 'Skilaboð frá greiðsluþjónustu: {error}',
      },
      pilotErrorPaymentProcessError: {
        title: 'Villa í samskiptum við greiðsluþjónustu',
        message: 'Skilaboð frá greiðsluþjónustu: {error}',
      },
      pilotErrorInvalidVerificationCode: {
        title: 'Staðfestingarkóði rangur',
        message: 'Athugaðu hvort hann sé rétt sleginn inn.',
      },
      pilotErrorCouponExpired: {
        title: 'Afsláttarkóði útrunninn',
        message: 'Kóðinn sem þú gafst upp er ekki virkur.',
      },
      pilotErrorCouponNotFound: {
        title: 'Afsláttarkóði finnst ekki',
        message: 'Athugaðu hvort hann sé rétt sleginn inn.',
      },
      pilotErrorInvalidCardNumber: {
        title: 'Kortanúmer ógilt',
        message: 'Athugaðu hvort þú hafir gefið upp rétt númer.',
      },
      pilotErrorExpiredCard: {
        title: 'Gildistími korts er útrunninn',
        message: 'Prófaðu annað kort eða annan greiðslumáta.',
      },
      pilotErrorInvalidCardLength: {
        title: 'Villa í kortanúmeri',
        message: 'Kortanúmer verður að vera 11 til 19 tölustafir',
      },
      pilotErrorOrderNotValid: {
        title: 'Engin pöntun fannst',
        message: 'Það getur gerst ef vöruúrval breytist.',
      },
      pilotErrorItemNotAllowedForDeliveryMethod: {
        title: 'Við getum ekki afgreitt vöru',
        message: 'Það er vara í pöntuninni sem er ekki í boði fyrir valinn afhendingarmöguleika.',
      },
      pilotErrorDeliveryMethodMinTotalPrice: {
        title: 'Lágmarksupphæð ekki náð',
        message: 'Til að geta valið þennan afhendingarmáta þarf að panta meira.',
      },
      pilotErrorCouponWrongDeliveryMethod: {
        title: 'Afsláttarkóði ekki leyfður',
        message: 'Þessi afsláttarkóði er ekki í boði fyrir þennan afhendingarmöguleika.',
      },
      pilotErrorInvalidPinNumber: {
        title: 'Rangt pin númer',
        message: 'Reyndu aftur.',
      },
      couponNeedsDesktop: {
        title: 'Afsláttarkóði ekki leyfður',
        message: 'Þessi afsláttarkóði er aðeins leyfður á vefnum.',
      },
      couponNeedsCordova: {
        title: 'Afsláttarkóði ekki leyfður',
        message: 'Þessi afsláttarkóði er aðeins leyfður í appi.',
      },
      notAllowed: {
        title: 'Aðgerð ekki framkvæmd',
        message: 'Notandi hefur ekki tilskilin leyfi.',
      },
      ECONNABORTED: {
        title: 'Samskipti runnu út á tíma',
        message: 'Keyrsla tók óeðlilega langan tíma.',
      },
    },
  },

  date: {
    days: ['Sunnudagur', 'Mánudagur', 'Þriðjudagur', 'Miðvikudagur', 'Fimmtudagur', 'Föstudagur', 'Laugardagur'],
    daysShort: ['Sun', 'Mán', 'Þri', 'Mið', 'Fim', 'Fös', 'Lau'],
    months: ['Janúar', 'Febrúar', 'Mars', 'Apríl', 'Maí', 'Júní', 'Júlí', 'Ágúst', 'September', 'Október', 'Nóvember', 'Desember'],
    monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maí', 'Jún', 'Júl', 'Ágú', 'Sep', 'Okt', 'Nóv', 'Des'],
    firstDayOfWeek: 1,
  },
};
